
const billRouter = [
    {
        path:'',
        name:'bill-index',
        component: () => import(/* webpackChunkName: "about" */ '../views/bill/index.vue'),
    }
]
export default billRouter